module.exports = __webpack_public_path__ + "img/logo_white.b5bc332e.png";